<template>
  <div :class="{ 'report': true, 'en-font': type == 'en', 'cn-font': type == 'cn' }" v-loading="loading">
    <web-header :language="type" ref="webHeaderRef" @session-change="refreshDetail"></web-header>
    <div class="report-wrap">
      <div :class="{ 'report-wrap-title': true, 'en-font-bold': type == 'en', 'cn-font-bold': type == 'cn' }">
        {{ info.product_name }}
      </div>
      <div class="report-wrap-opera" :style="{ padding: has_pdf ? '0' : '15px 0' }">
        <div :class="{ 'report-wrap-opera-text': true, 'roboto-light': type == 'en' }">
          <span v-if="type == 'cn'">{{ $moment(info.publish_time).format("YYYY-MM-DD") }}</span>
          <span v-else>{{ $moment(info.publish_time).format("LL") }}</span>
          <span v-if="info.author">{{ info.author }}</span>
        </div>
        <div class="report-wrap-opera-btn">
          <div :class="{ 'report-wrap-opera-btn-download': true, 'roboto-light': type == 'en' }" @click="downloadPdf" v-if="has_pdf">
            <i class="iconfont icon-downloadPDF"></i>
            <span>{{ type == 'en' ? 'Download PDF' : '下载报告' }}</span>
          </div>
          <div class="report-wrap-opera-btn-oa">
            <div class="report-wrap-opera-btn-oa-lump" @click="printFn">
              <i class="iconfont icon-print"></i>
            </div>
            <div class="report-wrap-opera-btn-oa-lump" @click="copyUrl">
              <i class="iconfont icon-share"></i>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showMediaAccess" class="report-media-access">
        <img v-if="info.img && info.img[0] && info.img[0].img" :src="info.img[0].img" alt="" />
        <div class="media-access-overlay">
          <el-button type="primary" round @click="showMediaDialog">{{ mediaAccessText.screen }}</el-button>
        </div>
      </div>
      <div class="report-wrap-file" v-if="audioInfo.url && audioInfo.url.img">
        <div class="report-wrap-file-name">
          <span v-if="audioInfo.title">{{ type == 'en' ? "Audio" : "音频" }}：{{ audioInfo.title }}</span>
        </div>
        <audio controls="" controlslist="nodownload" :src="audioInfo.url.img"></audio>
      </div>
      <div class="report-wrap-video" v-if="videoInfo.url && videoInfo.url.img">
        <video controls :poster="videoInfo.img && videoInfo.img.img ? videoInfo.img.img : ''" preload="metadata">
          <source :src="videoInfo.url.img" type="video/mp4">
        </video>
      </div>
      <div class="report-wrap-content">
        <div ref="previewBox" class="report-wrap-content-box" :class="{ 'is-restricted': isRestricted }" id="printContent" @load.capture="queuePreviewLayout">
          <div class="report-preview-viewport" :style="isRestricted && previewHeight !== null ? { height: previewHeight + 'px', overflow: 'hidden' } : null">
            <div ref="previewContent" class="report-wrap-content-box-substance" v-html="removeFontFamily(info.pdf_content)" v-if="info.pdf_content"></div>
            <div ref="previewContent" class="report-wrap-content-box-substance no-login" v-html="removeFontFamily(info.content)" v-else></div>
          </div>
          <div class="report-wrap-content-box-noCopy"></div>
          <div v-if="isRestricted" :class="['report-access-notice', { 'is-english': type === 'en' }]" :style="{ marginTop: -previewOverlap + 'px', '--preview-fade-height': previewOverlap + 'px' }">
            <img v-if="!info.is_logged_in" class="access-icon" src="@/assets/research-access/lock.svg" alt="" />
            <img v-else class="access-icon" src="@/assets/research-access/vip.svg" alt="" />
            <div class="access-message"><div>
              <template v-if="!info.is_logged_in">
                <template v-if="type === 'en'">
                  <button type="button" class="access-login" @click="login">Sign In</button><span> to continue reading.</span>
                </template>
                <template v-else>
                  <span>继续阅读，请点击 </span><button type="button" class="access-login" @click="login">登录</button>
                </template>
              </template>
              <template v-else>
                <span>{{ type === 'en' ? 'VIP Exclusive Content. Request a ' : '本文为VIP会员专享，' }}</span><button type="button" class="access-trial" @click="applyTrial">{{ type === 'en' ? 'Free Trial' : '申请试用' }}</button>
              </template>
            </div></div>
          </div>
        </div>
        <div class="report-wrap-content-copyright" v-if="type == 'cn'">
          <img src="~@/assets/cn_tip.png" />
        </div>
        <div class="report-wrap-content-copyright" v-if="type == 'en'">
          <img src="~@/assets/en_tip.png" />
        </div>
      </div>
    </div>
    <article-mail-subscription v-if="!loading && info.id && !isMedia" :language="type" />
    <pay-wechat ref="payWechatRef" :language="type"></pay-wechat>
    <web-footer :language="type"></web-footer>
  </div>
</template>

<script>
import WebHeader from "@/components/webHeader";
import WebFooter from "@/components/webFooter";
import PayWechat from "@/components/payWechat";
import ArticleMailSubscription from './component/mailSubscription.vue';
import print from 'print-js'
import { reportDetail, reportPdf, payPalCheck, autoLogin } from "@/api";
export default {
  name: "Report",
  components: {
    WebHeader,
    WebFooter,
    PayWechat,
    ArticleMailSubscription,
  },
  data() {
    return {
      loading: false,
      detailRequestId: 0,
      downloadingPdf: false,
      previewOverlap: 0,
      previewHeight: null,
      type: "cn",
      info: {},
      has_pdf:false,
      audioInfo: {},
      videoInfo: {},
    };
  },
  computed: {
    isMedia() { return [2, 3].includes(Number(this.info.product_type)); },
    isRestricted() { return Boolean(!this.loading && this.info.id && !this.info.is_buy && !this.isMedia); },
    showMediaAccess() { return !this.loading && this.info.id && this.isMedia && !this.info.is_buy; },
    mediaAccessText() {
      const isEnglish = this.type === 'en';
      if (this.info.is_logged_in) {
        return {
          screen: isEnglish ? 'VIP Members Only' : 'VIP会员专享',
          title: isEnglish ? 'Membership Required' : '会员提示',
          message: isEnglish ? 'This episode is exclusive to VIP members. Apply for a free trial to unlock it.' : '本期内容为VIP专享，如需解锁可申请试用',
          confirm: isEnglish ? 'Free Trial' : '申请试用',
        };
      }
      return {
        screen: isEnglish ? 'Please sign in to watch' : '请登录后观看',
        title: isEnglish ? 'Sign In Required' : '登录提示',
        message: isEnglish ? 'Sign in to unlock the full video' : '登录后解锁完整视频',
        confirm: isEnglish ? 'Sign In' : '登录',
      };
    },
  },
  created() {
    if (this.$route.params.id && this.isNumber(this.$route.params.id)) {
      if (this.$route.params.language && this.$route.params.language == "english") {
        this.type = "en";
      } else {
        this.type = "cn";
      }
      this.paySuccessTip();
      this.getDataInfo(this.$route.params.id);
    } else {
      this.$router.push('/404');
    }
  },
  mounted() {
    this.previewLayoutActive = true;
    if (window.ResizeObserver) {
      this.previewResizeObserver = new ResizeObserver(this.queuePreviewLayout);
      this.previewResizeObserver.observe(this.$refs.previewBox);
    }
    window.addEventListener('resize', this.queuePreviewLayout);
    if (document.fonts) document.fonts.ready.then(this.queuePreviewLayout);
    this.queuePreviewLayout();
  },
  beforeDestroy() {
    this.previewLayoutActive = false;
    if (this.previewResizeObserver) this.previewResizeObserver.disconnect();
    window.removeEventListener('resize', this.queuePreviewLayout);
    cancelAnimationFrame(this.previewLayoutFrame);
  },
  watch: {
    isRestricted() { this.$nextTick(this.queuePreviewLayout); }
  },
  methods: {
    queuePreviewLayout() {
      if (!this.previewLayoutActive) return;
      cancelAnimationFrame(this.previewLayoutFrame);
      this.previewLayoutFrame = requestAnimationFrame(this.updatePreviewOverlap);
    },
    updatePreviewOverlap() {
      const content = this.$refs.previewContent;
      if (!this.isRestricted || !content) {
        this.previewOverlap = 0;
        this.previewHeight = null;
        return;
      }
      // 用实际排版行计数，段间距和图片不算文字行；同一行的多个行内标签合并。
      const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
      const rects = [];
      let node;
      while ((node = walker.nextNode())) {
        if (!node.textContent.trim() || node.parentElement.closest('script, style')) continue;
        const range = document.createRange();
        range.selectNodeContents(node);
        rects.push(...Array.from(range.getClientRects()).filter(rect => rect.width > 0 && rect.height > 0));
      }
      rects.sort((a, b) => a.top - b.top || a.bottom - b.bottom);
      const lines = [];
      rects.forEach(rect => {
        const last = lines[lines.length - 1];
        if (last && rect.top < last.bottom - 1) last.bottom = Math.max(last.bottom, rect.bottom);
        else lines.push({ top: rect.top, bottom: rect.bottom });
      });
      if (!lines.length) {
        this.previewHeight = null;
        this.previewOverlap = 0;
        return;
      }
      // 电脑清晰展示10行，手机展示6行；短摘要留出末尾两行淡出，不补充付费正文。
      const clearLimit = window.matchMedia('(max-width: 767px)').matches ? 6 : 10;
      const clearCount = lines.length > clearLimit ? clearLimit : Math.max(0, lines.length - 2);
      const viewportTop = content.parentElement.getBoundingClientRect().top;
      const fadeTop = clearCount ? lines[clearCount - 1].bottom + 2 : lines[0].top;
      // 渐变仅覆盖后续最多3行，余下摘要直接裁掉，长度不再随整篇摘要增长。
      const fadeBottom = lines[Math.min(clearCount + 3, lines.length) - 1].bottom + 2;
      this.previewHeight = Math.ceil(fadeBottom - viewportTop);
      this.previewOverlap = Math.ceil(fadeBottom - fadeTop);
    },
    showMediaDialog() {
      const text = this.mediaAccessText;
      this.$confirm(text.message, text.title, {
        confirmButtonText: text.confirm,
        cancelButtonText: this.type === 'en' ? 'Cancel' : '取消',
        closeOnClickModal: false,
      }).then(() => {
        if (this.info.is_logged_in) this.applyTrial();
        else this.login();
      }).catch(() => {});
    },
    async getDataInfo(msgId) {
      const pending = window.__cf40EmailLogin;
      delete window.__cf40EmailLogin;
      const fragment = new URLSearchParams((this.$route.hash || '').slice(1));
      const emailCode = (pending && pending.path === this.$route.path ? pending.code : '')
        || fragment.get('emailCode') || this.$route.query.emailCode;
      if (emailCode) {
        const query = { ...this.$route.query };
        delete query.emailCode;
        const hasFragmentCode = fragment.has('emailCode');
        if (hasFragmentCode) fragment.delete('emailCode');
        if (this.$route.query.emailCode || hasFragmentCode) {
          await this.$router.replace({ path: this.$route.path, query,
            hash: hasFragmentCode ? (fragment.toString() ? '#' + fragment.toString() : '') : this.$route.hash });
        }
        try {
          const res = await autoLogin({ emailCode }, this.type === 'en' ? 'en' : '');
          if (res && res.code == 200 && res.data && res.data.token) {
            localStorage.setItem("cf40-token", res.data.token);
            await this.$nextTick();
            if (this.$refs.webHeaderRef) this.$refs.webHeaderRef.loginSuccess();
          } else {
            this.$message.warning((res && res.msg) || (this.type === 'en'
              ? 'This email sign-in link is no longer valid. Please sign in normally.'
              : '邮件登录链接已失效，请正常登录'));
          }
        } catch (error) {
          this.$message.warning(this.type === 'en'
            ? 'Email sign-in is temporarily unavailable. Please sign in normally.'
            : '邮件自动登录暂不可用，请正常登录');
        }
      }
      await this.getLoginDetail(msgId);
    },
    refreshDetail() { return this.getLoginDetail(this.$route.params.id); },
    applyTrial() { this.$router.push({ name: 'InstitutionApplication', params: { language: this.type === 'en' ? 'english' : 'chinese' } }); },
    async getLoginDetail(id) {
      const requestId = ++this.detailRequestId;
      this.loading = true;
      this.info = {};
      this.audioInfo = {};
      this.videoInfo = {};
      this.has_pdf = false;
      try {
      let res = await reportDetail({ id: id }, this.type === 'en');
      if (requestId !== this.detailRequestId) return;
      if (res && res.code == 200) {
        this.info = res.data;
        if (this.info.pdf_url_id>0){
          this.has_pdf = true;
        }
        if (res.data && res.data.is_buy) {
          if (res.data.product_type == 1) {
            this.isReportAudioOrVideo(res.data.product_detail);
          } else if (res.data.product_type == 2) {
            if (res.data.product_detail && res.data.product_detail.length > 0) {
              this.audioInfo = res.data.product_detail[0];
            }
          } else if (res.data.product_type == 3) {
            if (res.data.product_detail && res.data.product_detail.length > 0) {
              this.videoInfo = res.data.product_detail[0];
            }
          }
        }
      }
      } catch (error) { /* 请求层显示失败信息，保留空内容以便重试。 */ }
      finally { if (requestId === this.detailRequestId) this.loading = false; }
    },
    async downloadPdf() {
      if (this.downloadingPdf) return;
      this.downloadingPdf = true;
      const downLoading = this.$loading({
        lock: true,
        text: this.type == 'en' ? 'Loading...' : '正在处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      const fallback = this.type === 'en' ? 'PDF download failed. Please try again.' : 'PDF 下载失败，请重试';
      try {
        const res = await reportPdf({ id: this.info.id }, this.type === 'en' ? 'en' : '');
        // 旧接口业务失败也可能返回 HTTP 200，必须确认内容后才能保存为 PDF。
        if (!(res instanceof Blob) || !(await res.slice(0, 1024).text()).startsWith('%PDF-')) {
          let message = res && res.msg;
          if (res instanceof Blob) {
            try { message = JSON.parse(await res.text()).msg; } catch (error) { /* 非 JSON 错误页使用默认提示。 */ }
          }
          throw new Error(message || fallback);
        }
        const name = (this.info.product_name || 'document').replace(/\.pdf$/i, '')
          .replace(/[\\/:*?"<>|]/g, '_').split('')
          .filter(char => char.charCodeAt(0) >= 32).join('').trim() || 'document';
        const url = window.URL.createObjectURL(res);
        this.routerLink(url, true, name + '.pdf');
        setTimeout(() => window.URL.revokeObjectURL(url), 60000);
      } catch (error) {
        this.$message.error(error.isAxiosError ? fallback : error.message || fallback);
      } finally {
        downLoading.close();
        this.downloadingPdf = false;
      }
    },
    isReportAudioOrVideo(rows) {
      if (rows && rows.length > 0) {
        let temp = rows[0];
        if (temp.product_type == 2) {
          this.audioInfo = temp;
        } else if (temp.product_type == 3) {
          this.videoInfo = temp;
        }
      }
    },
    removeFontFamily(htmlContent) {
      let parser = new DOMParser();
      let doc = parser.parseFromString(htmlContent, 'text/html');
      let elements = doc.querySelectorAll('*');
      elements.forEach(function(el) {
        let style = el.getAttribute('style');
        if (style) {
          let styles = style.split(';');
          styles = styles.filter(function(s) {
            return !s.trim().startsWith('font-family');
          });
          el.setAttribute('style', styles.join('; '));
        }
      });
      return doc.body.innerHTML;
    },
    printFn() {
      setTimeout(function () {
        print({
          printable: 'printContent',
          type: 'html',
          scanStyles: false,
          targetStyles: ['*']
        })
      }, 500);
    },
    async copyUrl() {
      const textarea = document.createElement('textarea');
      textarea.value = window.location.href;
      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, 9999);
      try {
        document.execCommand('copy');
        this.$message.success('当前地址（URL）已复制到剪贴板')
      } catch (err) {
        this.$message.error("当前地址（URL）复制失败，请手动复制分享")
      }
      document.body.removeChild(textarea);
    },
    unlockReport() {
      let token = localStorage.getItem("cf40-token");
      if (token && this.info.id && !this.info.is_buy) {
        this.$refs.payWechatRef.open(this.info.id);
      } else {
        this.$refs.webHeaderRef.login();
      }
    },
    login() {
      this.$refs.webHeaderRef.login();
    },
    async checkPayPal(token) {
      let lang = this.type == "en" ? "en" : "";
      let res = await payPalCheck({ orderId: token }, lang);
      if (res && res.code == 200) {
        if (res.msg) {
          this.$message.success(res.msg);
        } else {
          this.$message.success(lang ? "Payment successful" : "支付成功");
        }
      }
    },
    paySuccessTip() {
      if (this.$route.query.retracement && this.$route.query.retracement == 'success') {
        if (this.$route.query.token) {
          this.checkPayPal(this.$route.query.token);
        }
        if (this.type == 'en') {
          this.$alert(`<p style="font-family: Georgia;">
                                PayPal payment may be delayed. If your payment has been completed and there are no changes on the page, please wait for 1 minute before refreshing and trying again</p>`,
              `Reminder`, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: 'Done',
                confirmButtonClass: "confirm-button",
                callback: (action) => {
                  if (action == "confirm") {
                    window.location.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
                  }
                }
              });
        } else {
          this.$alert(`PayPal支付可能有延迟，如您支付已完成，页面无变化，请等待1分钟后刷新重试`, '温馨提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            confirmButtonClass: "confirm-button",
            callback: (action) => {
              if (action == "confirm") {
                window.location.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
              }
            }
          });
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.report-media-access {
  position: relative;
  width: 600px;
  max-width: 100%;
  height: 300px;
  margin: 30px auto 0;
  background: #211816;
  overflow: hidden;
  img { width: 100%; height: 100%; object-fit: contain; }
  .media-access-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
  }
}

.en-font {
  font-family: Georgia;
}
.en-font-bold {
  font-family: Georgia_Bold;
}
.cn-font {
  font-family: HarmonyOS_Sans_Regular;
}
.cn-font-bold {
  font-family: HarmonyOS_Bold;
}
.roboto-light {
  font-family: Roboto_Light;
}
.roboto-bold {
  font-family: Roboto_Bold;
}
.report {
  &-wrap {
    width: 50%;
    margin: 50px auto 80px auto;
    &-title {
      padding: 30px 40px 40px 0;
      font-size: 38px;
    }
    &-opera {
      padding: 5px 0;
      border-top: 1px solid #dadada;
      border-bottom: 1px solid #dadada;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &-text {
        color: #747474;
        span {
          font-size: 12px;
          &:after {
            content: '|';
            padding: 0 15px;
          }
          &:last-child {
            &:after {
              display: none;
            }
          }
        }
      }
      &-btn {
        display: flex;
        &-download {
          cursor: pointer;
          user-select: none;
          padding: 15px 15px;
          border-left: 1px solid #dedede;
          border-right: 1px solid #dedede;
          margin-right: 20px;
          color: #ed6f33;
          display: flex;
          align-items: center;
          text-decoration: none;
          background-color: #f7f7f7;
          i {
            font-size: 28px;
            margin-right: 10px;
          }
        }
        &-oa {
          display: flex;
          justify-content: center;
          align-items: center;
          &-lump {
            width: 30px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            margin-left: 20px;
            color: #0b0b0b;
            cursor: pointer;
            background-color: #f7f7f7;
            border: 1px solid #ebebeb;
            border-radius: 50%;
            &:last-child {
              margin-right: 20px;
            }
            &:hover, &.active {
              color: #fff;
              background-color: #ed6f33;
            }
          }
        }
      }
    }
    &-file {
      margin-top: 30px;
      border: 1px solid #EBEBEB;
      height: 45px;
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
      &-name {
        font-size: 16px;
        display: inline-block;
        margin-left: 50px;
        position: relative;
      }
      audio {
        width: 250px;
        position: relative;
        margin-right: 30px;
        border: 0;
        outline: none;
      }
    }
    &-video {
      margin-top: 30px;
      text-align: center;
      video {
        width: 600px;
        height: 300px;
      }
    }
    &-content {
      position: relative;
      margin-top: 30px;
      padding-top: 30px;
      min-height: 400px;
      &-box {
        position: relative;
        &-substance {
          padding-bottom: 20px;
          word-wrap: break-word;
          ::v-deep {
            p {
              font-size: 16px;
              line-height: 32px;
              text-align: justify;
              margin-bottom: 18px;
              a {
                text-decoration: none;
              }
              &:has(img) {
                text-align: center !important;
              }
            }
            blockquote {
              margin: 10px 0;
              padding: 10px;
              display: block;
              background-color:#f5f2f0;
              border-left:8px solid #c9a63e;
            }
            img {
              max-width: 86%;
            }
          }
        }
        &-noCopy {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 6;
          opacity: 0;
        }
      }
      &-copyright {
        text-align: center;
        //color: #777777;
        //padding: 20px 30px;
        //text-align: center;
        //border-radius: 10px;
        //border: 2px solid #e1e1e1;
        //.title {
        //  font-size: 18px;
        //}
        //.desc {
        //  margin-top: 10px;
        //  font-size: 16px;
        //  line-height: 26px;
        //}
      }
    }
  }
}
/* 针对笔记本屏幕或者缩放屏幕 */
@media screen and (min-width: 1024px) and (max-width: 1600px) {
  .report {
    &-wrap {
      width: 70%;
    }
  }
}
/* 针对平板 */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .report {
    &-wrap {
      width: 90%;
      min-height: 300px;
      margin: 20px auto 40px auto;
      &-title {
        padding: 15px 20px 15px 0;
        font-size: 30px;
      }
      &-content {
        min-height: 300px;
      }
      &-next {
        margin-top: 50px;
        a {
          font-size: 30px;
        }
      }
    }
  }
}
/* 针对手机 */
@media screen and (max-width: 767px) {
  .report {
    &-wrap {
      width: calc(100% - 30px);
      min-height: 300px;
      margin: 10px auto 20px auto;
      &-title {
        padding: 15px 20px 15px 0;
        font-size: 22px;
      }
      &-opera {
        &-text {
          span {
            font-size: 12px;
            &:after {
              padding: 0 5px;
            }
          }
        }
        &-btn {
          &-download {
            font-size: 12px;
            padding: 12px 5px;
            i {
              font-size: 22px;
              margin-right: 5px;
            }
          }
          &-oa {
            display: none;
          }
        }
      }
      &-file {
        margin-top: 30px;
        border: 1px solid #EBEBEB;
        height: inherit;
        padding: 15px 0;
        flex-direction: column;
        margin-bottom: 12px;
        &-name {
          font-size: 14px;
          margin-left: 0;
        }
        audio {
          width: revert;
          margin-top: 10px;
          max-width: 100%;
          position: relative;
          margin-right: 0;
        }
      }
      &-video {
        margin-top: 30px;
        text-align: center;
        video {
          width: 100%;
          height: 260px;
        }
      }
      &-content {
        min-height: 300px;
        margin-top: 15px;
        &-box {
          &-substance {
            ::v-deep {
              img {
                max-width: 100%;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import '@/styles/researchAccess.scss';

.report-access-notice {
  box-sizing: border-box;
  position: relative;
  z-index: 9;
  width: 100%;
  min-height: 278px;
  padding: calc(var(--preview-fade-height, 0px) + 24px) 12px 49px;
  color: #1e1e1e;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0), #fff var(--preview-fade-height, 0px));
  text-align: center;
  font-family: 'Research Access Chinese', sans-serif;
  .access-icon { display: block; width: 76px; height: 76px; margin: 0 auto 10px; }
  .access-message { display: flex; align-items: center; justify-content: center; max-width: 576px; min-height: 59px; margin: 0 auto; font-size: 28px; line-height: 1.3; }
  button {
    box-sizing: border-box;
    height: 42px;
    margin: 0;
    padding: 0 6px;
    border: 0;
    border-radius: 6px;
    color: #fff;
    background: #ed6f33;
    font: inherit;
    line-height: 42px;
    white-space: nowrap;
    vertical-align: baseline;
    cursor: pointer;
    &:focus-visible { outline: 2px solid #a8491c; outline-offset: 3px; }
  }
  .access-login { min-width: 68px; }
  .access-trial { min-width: 124px; }
  &.is-english {
    font-family: 'Research Access English', Georgia, serif;
    .access-login { min-width: 121px; }
    .access-trial { min-width: 138px; }
  }
}
.report-preview-viewport { display: flow-root; }
@media screen and (max-width: 767px) {
  .report-access-notice {
    padding-right: 0;
    padding-left: 0;
    .access-message { font-size: 20px; }
    button { height: 36px; line-height: 36px; }
    .access-login, .access-trial, &.is-english .access-login, &.is-english .access-trial { min-width: 0; }
  }
}
</style>
